import {
    Box,
    Step,
    StepButton,
    StepConnector,
    StepLabel,
    Stepper,
    styled,
    Typography,
} from '@mui/material';
import bgServicePayment from 'assets/images/icons/campaign-data-collection/bg-service-payment.jpg';
import bgElectronicInvoice from 'assets/images/icons/campaign-data-collection/bg-electronic-invoice.jpg';
import bgPayment from 'assets/images/icons/campaign-data-collection/bg-payment.jpg';
import { colors } from 'common/constants';
import { CampaignContainer } from 'pages/admin/campaign-overview/campaign-container';
import React, { useState } from 'react';
import SelectObject from './select-object';
import ElectronicInvoice from './electronic-invoice';
import Payment from './payment';
import { useAppSelector } from 'common/hook';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'plugins/store';
import CampaignConstants from 'pages/admin/campaign/constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CustomStepIcon = ({ active, completed, className, step }: any) => {
    return (
        <div
            className={className}
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '30px',
                height: '30px',
                borderRadius: '50%',
                backgroundColor: completed
                    ? colors.main
                    : active
                      ? colors.main
                      : '#fff',
                color: completed ? '#fff' : active ? '#fff' : '#000',
                fontWeight: 'bold',
                fontSize: '1rem',
            }}
        >
            {step + 1}
        </div>
    );
};

export const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
    '& .MuiStepConnector-line': {
        border: 'none',
        position: 'relative',
        width: '100%',
        height: '2px',
        backgroundColor: theme.palette.grey[400],
    },
    '&.Mui-completed .MuiStepConnector-line': {
        backgroundColor: colors.main,
    },
    '&.Mui-active .MuiStepConnector-line': {
        backgroundColor: colors.main,
    },
}));

const ServicePayment = () => {
    const steps = ['Chọn đối tượng', 'Hóa đơn điện tử', 'Thanh toán'];
    const [activeStep, setActiveStep] = useState(0);
    const navigate = useNavigate();

    const handleStepClick = (index: number) => {
        setActiveStep(index);
    };

    const config: Record<number, React.ReactElement> = {
        0: <SelectObject tabIndex={0} setActiveStep={setActiveStep} />,
        1: <ElectronicInvoice tabIndex={1} setActiveStep={setActiveStep} />,
        2: <Payment tabIndex={2} />,
    };
    const listBackgroundImage = [
        bgServicePayment,
        bgElectronicInvoice,
        bgPayment,
    ];
    const currentCampaign = useAppSelector(
        (state: RootState) => state.campaignState.campaign
    );
    React.useEffect(() => {
        if (!currentCampaign) return;
        if (
            currentCampaign?.status_client !==
            CampaignConstants.status.CLIENT_DRAFT
        ) {
            navigate(
                `/admin/campaign/data-collect/${currentCampaign.id}/survey-active`
            );
        } else if (
            currentCampaign.paymentStatus.status === 'pending' &&
            currentCampaign.paymentStatus.url_payment &&
            !currentCampaign.paymentStatus.is_expired
        ) {
            navigate(
                `/admin/campaign/data-collect/${currentCampaign.id}/payment-results`
            );
        }
    }, [currentCampaign, navigate]);
    return (
        <CampaignContainer>
            <Box
                sx={{
                    height: '387px',
                    borderRadius: '30px',
                    backgroundImage: `url(${listBackgroundImage[activeStep]})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    padding: '135px 145px',
                    marginBottom: '16px',
                }}
            >
                <Typography
                    variant="h3"
                    sx={{
                        fontSize: '80px',
                        fontWeight: 700,
                        lineHeight: '96px',
                        color: (theme) => theme.palette.common.white,
                    }}
                >
                    Thanh toán dịch vụ
                </Typography>
            </Box>
            <Typography
                variant="h3"
                sx={{
                    fontSize: '50px',
                    fontWeight: 600,
                    lineHeight: '60px',
                    marginBottom: '34px',
                }}
            >
                {currentCampaign?.campaign}
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    fontSize: '28px',
                    lineHeight: '40px',
                    fontWeight: 400,
                    marginBottom: '33px',
                }}
            >
                Hoàn tất việc thanh toán này, hệ thống sẽ tự động chọn lựa các
                ứng viên phù hợp nhất với yêu cầu đối tượng và lần lượt gửi bằng
                khảo sát của bạn đến những đáp viên này qua SMS.
                <Typography
                    component={'a'}
                    sx={{
                        color: '#0088FF',
                        textDecoration: 'none',
                        fontSize: '28px',
                    }}
                    href="#"
                >
                    Tìm hiểu thêm về cách chống gian lận.
                </Typography>
            </Typography>
            <Box sx={{ width: '60%', mx: 'auto' }}>
                <Stepper
                    nonLinear
                    activeStep={activeStep}
                    alternativeLabel
                    connector={<CustomStepConnector />}
                    sx={{
                        '.MuiStepLabel-label': {
                            textAlign: 'center',
                            fontSize: '1rem',
                        },
                        '.MuiStepButton-root': {
                            fontSize: '1.2rem',
                        },
                        '.MuiSvgIcon-root': {
                            fontSize: '1.7rem',
                        },
                        '.MuiStepConnector-line': {
                            backgroundColor: 'grey',
                        },
                        '.Mui-active .MuiStepConnector-line': {
                            backgroundColor: 'primary.main',
                        },
                        '.Mui-completed .MuiStepConnector-line': {
                            backgroundColor: 'primary.main',
                        },
                    }}
                >
                    {steps.map((item, index) => (
                        <Step key={index} completed={index < activeStep}>
                            <StepButton
                                disableRipple
                                onClick={() => {
                                    if (index <= activeStep) {
                                        handleStepClick(index);
                                    }
                                }}
                                sx={{
                                    '&.Mui-active': {
                                        color: 'primary.main',
                                    },
                                    '&.Mui-completed': {
                                        color: 'success.main',
                                    },
                                }}
                            >
                                <StepLabel
                                    sx={{
                                        '& .MuiStepLabel-label': {
                                            fontSize: '1.5rem',
                                            fontWeight: 500,
                                        },
                                    }}
                                    StepIconComponent={(props) => (
                                        <CustomStepIcon
                                            {...props}
                                            step={index}
                                        />
                                    )}
                                >
                                    {item}
                                </StepLabel>
                            </StepButton>
                        </Step>
                    ))}
                </Stepper>
            </Box>
            <Box>{config[activeStep] || <div>Content not found</div>}</Box>
            <Box></Box>
        </CampaignContainer>
    );
};

export default ServicePayment;
